﻿import React, { useState, useEffect } from 'react';
import { TitrationBenchSheet } from '../models/titration-bench-sheet';
import { BenchSheetTechnologyType, DocumentType, NoteType, Entities } from '../models/enums';
import TitrationInstrument from './TitrationInstrument';
import SamplePreparationsComponent from './SamplePreparations/SamplePreparationsComponent';
//import SamplePreparationsDataComponent from './SamplePreparationsDataComponent';
import TitrantStandardizationsComponent from './TitrantStandardizationsComponent';
import TitrationAnalysisData from './TitrationAnalysisData';
import BenchSheetHeaderComponent from './BenchSheetHeaderComponent';
import BenchSheetData from './BenchSheetData';
import { CrudFunctions } from '../utilities/crud-functions';
import { UserDataStore } from '../store/userDataStore';
import { FieldUpdate } from '../models/field-update';
import NoteViewer from './NoteViewer';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';
import ItemBasicInformationDialog from './ItemBasicInformationDialog';
import { ItemBasicInformation } from '../models/item-basic-information';
import { DocumentationConstants } from '../store/documentation-constants';
import TicketLogEntryForm from './TicketLogEntryForm';
import BenchSheetToolbar from './BenchSheetToolbar';

import { Popup as DialogPopup } from 'devextreme-react/popup';
import RadioGroup from 'devextreme-react/radio-group';
import NumberBox from 'devextreme-react/number-box';
import SelectBox from 'devextreme-react/select-box';
import CheckBox from 'devextreme-react/check-box';

let key = 1;

//temp
const instrumentTypes = [
    { id: 1, name: "Manual" },
    { id: 2, name: "Auto" }
];

//temp
const driveTypes = [
    { id: 1, name: "Drive 1" },
    { id: 2, name: "Drive 2" }
];

//temp
const probeTypes = [
    { id: 1, name: "Probe 1" },
    { id: 2, name: "Probe 2" }
];


export default function TitrationBenchSheetForm() {
    const [canEdit, setCanEdit] =
        useState<boolean>(false);

    const [benchSheet, setBenchSheet] =
        useState<TitrationBenchSheet>();

    const [ticketLogEntryDialogVisible, setTicketLogEntryDialogVisible] =
        useState<boolean>(false);

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [dataLoaded, setDataLoaded] =
        useState<boolean>();

    useEffect(() => {
        setAuthorizations();
        getAllData();
    }, []);

    const parts = window.location.href.split('/');
    const benchSheetId = parts[parts.length - 1];

    key++;

    /*
    const selectedProbe = () => {
        if (benchSheet && benchSheet.probeId) {
            const matchingProbe = probeTypes.find(p => p.id === benchSheet.probeId);

            console.log("FOUND A PROBE...");
            console.log(matchingProbe);

            return matchingProbe;
        }

        return null;
    }
    */

    return (
        <div className="pw-form-container">
            <div className="pw-content">
                <BenchSheetToolbar title="Titration Bench Sheet"
                    subtitle="Titration"
                    auditRowPointer={benchSheetId} entity={Entities.TitrationBenchSheets}
                    technologyId={BenchSheetTechnologyType.Titration}
                    documentationId={DocumentationConstants.TITRATIONBenchSheets}
                    showItemInformation={showBenchSheetInformationDialog}
                    showTicketLog={showTicketLogEntryDialog} />

                <BenchSheetHeaderComponent benchSheetId={benchSheetId} readOnly={!canEdit} />

                <div className='pw-comp-row'>
                    <div className="pw-form-unit">
                        <CheckBox id="asIs" className="pw-check-box"
                            text="As Is" readOnly={!canEdit}
                            onValueChanged={onValueChanged}
                            value={benchSheet && benchSheet.asIs ?
                                benchSheet.asIs : false} />
                    </div>
                    <div className="pw-form-unit">
                        <CheckBox id="dried" className="pw-check-box"
                            text="Dried" readOnly={!canEdit}
                            onValueChanged={onValueChanged}
                            value={benchSheet && benchSheet.dried ?
                                benchSheet.dried : false} />
                    </div>
                    <div className="pw-form-unit">
                        <CheckBox id="anhydrous" className="pw-check-box"
                            text="Anhydrous" readOnly={!canEdit}
                            onValueChanged={onValueChanged}
                            value={benchSheet && benchSheet.anhydrous ?
                                benchSheet.anhydrous : false} />
                    </div>
                    <div className="pw-form-unit">
                        <CheckBox id="na" className="pw-check-box"
                            text="NA" readOnly={!canEdit}
                            onValueChanged={onValueChanged}
                            value={benchSheet && benchSheet.na ?
                                benchSheet.na : false} />
                    </div>
                </div>

                <div className="pw-margin-top-1">
                    <TitrationInstrument isReadOnly={!canEdit} benchSheetId={benchSheetId} />
                </div>

                <div className="pw-margin-top-1">
                    <SamplePreparationsComponent benchSheetId={benchSheetId} diluent={true} />
                </div>

                <TitrantStandardizationsComponent benchSheetId={benchSheetId} isReadOnly={!canEdit} />

                <SamplePreparationsComponent benchSheetId={benchSheetId} diluent={false} />

                <TitrationAnalysisData benchSheetId={benchSheetId} isReadOnly={!canEdit} />

                <div className="pw-comp-row-scroll-fixed-grid">
                    <BenchSheetData parentId={benchSheetId}
                        readOnly={!canEdit} canDelete={true}
                        technology={BenchSheetTechnologyType.Titration}
                        documentType={DocumentType.General}
                        imageHandlerTitle="Weight Ticket" />
                </div>

                <div className="pw-comp-row-scroll-fixed-grid">
                    <NoteViewer height='10rem' title="Bench Sheet Note"
                        noteType={NoteType.Method} parentId={benchSheetId} />
                </div>
            </div>

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width={'25rem'}
                    height={'21rem'}
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

            {ticketLogEntryDialogVisible &&
                <DialogPopup visible={ticketLogEntryDialogVisible}
                    onHiding={hideTicketLogEntryDialog}
                    title="Ticket Log Entry"
                    width={'55rem'}
                    height={'45rem'}
                    dragEnabled={true}
                    resizeEnabled={true}>
                    <TicketLogEntryForm formName="Conductivity Bench Sheet" contextData={benchSheet}
                        onCancel={hideTicketLogEntryDialog}
                        onComplete={hideTicketLogEntryDialog}
                        key={`TLE${key}`} />
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    function setAuthorizations() {
        const user = UserDataStore.getCurrentUser();

        const canEditRoles = ["SA", "MF-A", "MF-L", "MF-T", "PP-A", "PP-L", "PP-T", "DIST-A", "BA-A", "QCP-A", "QCD-A", "RD-A", "RD-L", "RD-T"];
        const canEdit = canEditRoles.some(r => user.roleCodes && user.roleCodes.includes(r));

        setCanEdit(canEdit);
    }

    async function onValueChanged(e: any) {
        if (!dataLoaded)
            return;

        const caller = e.element.id as string;

        if (caller && benchSheet) {
            const bs = benchSheet as any;
            const currentValue = bs[caller];

            if (currentValue === e.value)
                return;
            else if (!currentValue && !e.value)
                return;
            else {
                setBenchSheet({ ...benchSheet, [caller]: e.value });

                let fieldUpdate: FieldUpdate = {
                    entity: "TitrationBenchSheets",
                    field: caller,
                    value: e.value,
                    rowId: benchSheetId
                };

                await updateField(fieldUpdate)
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Field");
                    });
            }
        }
    }

    //GET methods

    async function getBenchSheet() {
        await CrudFunctions.getData(`benchsheets/benchsheet/${benchSheetId}`)
            .then(data => {

                console.log("TITRATION BS:");
                console.log(data);

                setBenchSheet(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Bench Sheet Data");
            });
    }

    // PUT functions

    async function updateField(fieldUpdate: FieldUpdate) {
        return CrudFunctions.putData("benchsheets/titrationbenchsheetfield", fieldUpdate);
    }

    function showTicketLogEntryDialog() {
        setTicketLogEntryDialogVisible(true);
    }

    function hideTicketLogEntryDialog() {
        setTicketLogEntryDialogVisible(false);
    }

    function showBenchSheetInformationDialog() {
        if (benchSheet) {
            let itemInformation: ItemBasicInformation = {
                rowPointer: benchSheet.benchSheetId,
                createTimestamp: benchSheet.createTimestamp,
                lastModifiedTimestamp: benchSheet.modifyTimestamp,
                createUser: benchSheet.createUser,
                modifyUser: benchSheet.modifyUser
            };

            setItemBasicInformation(itemInformation);
            setItemBasicInformationDialogVisible(true);
        }
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    async function getAllData() {
        await getBenchSheet()
            .then(() => setDataLoaded(true));
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}
